import React from 'react';
import CSS from 'csstype';
import '../../css/railEnhancements.css';
import AdComponent, { setConfig } from 'ad-react-wrapper';
import configAd from '../../../src/configAd.js';
import { AddAtErrorPageUuid, isHdfcSmartBuyUrl } from '../../../src/constants/TrainConstants'
setConfig(configAd);

const errBtnStyle: CSS.Properties ={
  display: 'inline-block',
  fontWeight: 600,
  backgroundColor: '#fff',
  border: '1px solid #008cff',
  borderRadius: '96px',
  color: '#008cff',
  fontSize: '14px',
  height: '34px',
  lineHeight: '32px',
  padding: '0 20px',
  textAlign: 'center',
  fontFamily: 'Lato-Bold,Arial,Helvetica,sans-serif',
  outline: 'none!important',
  cursor: 'pointer',
};

const errBtnContainer: CSS.Properties = {
  display: 'flex',
  justifyContent: 'center',
};

const errMsgContainer: CSS.Properties = {
  marginTop: '40',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const ErrorPage = (props) => {

  const searchNewDate = (e) => {
    e.preventDefault();
    if (props.handleSearchNewDate) {
      props.handleSearchNewDate();
    }
  }

  const { errorImg, errorTitle, errorMsg, trainsClosed, btnText } = props;
  const errImg = require(`../../images/${errorImg}`);

    if (trainsClosed) {
      return (
        <div className="errorMsgCont" style={ errMsgContainer }>
          <div className="errorImg textCenter"><img style={{ width: '200px' }} src={`${errImg}`} alt="" /></div>
          <p className="font20 darkGreyText textCenter appendTop30" style= {{ width: 800 }} >{errorTitle}</p>
          <div className="appendTop20" style={errBtnContainer}>
            <a style={errBtnStyle} onClick={searchNewDate}>{btnText || 'Search New Dates'}</a>
          </div>
        </div>
      );
    }

    return (
      <div className="errorMsgCont">
        {!isHdfcSmartBuyUrl()  &&<div className="errorImg appendTop80 displayFlex">
          <AdComponent uuid={AddAtErrorPageUuid} />
        </div>}
        <div className="errorImg appendTop20 textCenter"><img src={`${errImg}`} alt="" /></div>
        <p className="latoBold font20 blackText textCenter appendTop30">{errorTitle}</p>
        <p className="errorMsg latoRegular font16 darkGreyText textCenter appendTop15">{errorMsg}</p>
      </div>
    );
  }

export default ErrorPage;
